module.exports = __webpack_public_path__ + "img/matte.fd8f2358.png";